import React from 'react';
import { Star } from 'lucide-react';

const TESTIMONIALS = [
  { name: 'Marcus T.', location: 'Virginia Beach, VA', quote: 'Johnnie hooked me up for my wedding — the whole groomsmen party wore his bow ties. Absolute class!' },
  { name: 'Derrick W.', location: 'Norfolk, VA', quote: 'Best bow tie selection I have ever seen. The quality is amazing and Johnnie helped me pick the perfect one for prom.' },
  { name: 'Anthony R.', location: 'Chesapeake, VA', quote: 'I get compliments every Sunday at church. The Bow Tie Guy is the real deal — style and service.' },
  { name: 'James H.', location: 'Portsmouth, VA', quote: 'Ordered a necktie set for a gala. Fast shipping, beautiful packaging, and the fit was perfect.' },
];

const Testimonials = () => (
  <section id="testimonials" data-testid="testimonials-section" className="py-16 sm:py-20 bg-[#001B2A]">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="text-center mb-12">
        <h2 className="text-3xl sm:text-4xl font-serif font-bold text-white mb-3">What Customers Say</h2>
        <p className="text-[#E6D7B3] text-lg">Real words from gentlemen who trust The Bow Tie Guy</p>
      </div>
      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {TESTIMONIALS.map((t) => (
          <div key={t.name} data-testid={`testimonial-${t.name.replace(/[^a-zA-Z]/g, '')}`} className="bg-white/5 border border-white/10 rounded-lg p-6 backdrop-blur-sm">
            <div className="flex gap-1 mb-4">
              {[...Array(5)].map((_, i) => (
                <Star key={i} className="h-4 w-4 fill-[#E6D7B3] text-[#E6D7B3]" />
              ))}
            </div>
            <p className="text-gray-200 italic mb-4 text-sm leading-relaxed">&ldquo;{t.quote}&rdquo;</p>
            <p className="text-white font-semibold text-sm">{t.name}</p>
            <p className="text-gray-400 text-xs">{t.location}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
